<template>
    <div id="layout-header">
        <div class="site-logo">
            <router-link to="/">
                <span><img :src="this.$store.state.webConfig.logo"></span>
                <span class="site-name">{{ this.$store.state.webConfig.name }}</span>
            </router-link>
        </div>
        <div class="site-menus">
            <div class="menu-item header-search">
                <header-search></header-search>
            </div>
            <div class="menu-item">
                <router-link to="/"><i class="iconfont icon-zhuye"/>首页</router-link>
            </div>
            <div class="menu-item hasChild">
                <router-link to="/category"><i class="iconfont icon-16"/>文章</router-link>
                <div class="childMenu" v-if="categoryList.length">
                    <div class="sub-menu" v-for="item in categoryList" :key="item.id">
                        <router-link :to="`/category/${item.id}`">{{ item.name }}({{ item.articleNum }})</router-link>
                    </div>
                </div>
            </div>
            <div class="menu-item">
                <router-link to="/source"><i class="iconfont icon-HTMLyuanma"/>源码</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/tool"><i class="iconfont icon-gongju"/>工具</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/tag"><i class="iconfont icon-24gf-tags2"/>标签</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/timeAxis"><i class="iconfont icon-shijian"/>时间轴</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/friendChain"><i class="iconfont icon-lianjie"/>友链</router-link>
            </div>
            <div class="menu-item">
                <router-link to="/about"><i class="iconfont icon-guanyu"/>关于</router-link>
            </div>
        </div>
        <div class="menu-user">
            <header-user></header-user>
        </div>
    </div>
</template>

<script>
    import {listCategory} from "@/api";
    import HeaderSearch from "@/components/header/header-search";
    import HeaderUser from "@/components/header/header-user";

    export default {
        name: "layout-header",
        components: {HeaderUser, HeaderSearch},
        data() {
            return {
                categoryList: []
            }
        },
        mounted() {
            this.getWebSiteInfo();
            this.listCategory();
        },
        methods: {
            // 查询网站信息
            getWebSiteInfo() {
                this.$store.dispatch('setWebInfo');
            },
            // 查询分类
            listCategory() {
                listCategory().then(res => {
                    this.categoryList = res.data
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>
<style scoped lang="less">
    #layout-header {
        position: fixed;
        top: 0;
        z-index: 2000;
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: .3s all ease;
        -webkit-transition: .3s all ease;
        -moz-transition: .3s all linear;
        -o-transition: .3s all ease;
        -ms-transition: .3s all ease;
        background-color: hsla(0, 0%, 100%, .9);
    }

    a {
        text-decoration: none;
        color: #545454;
    }

    .site-logo {
        padding-left: 70px;
    }

    .site-logo img {
        width: 50px;
        height: 50px;
    }

    .site-name {
        font-size: 18px;
        font-weight: bold;
        position: relative;
        top: -20px;
        padding-left: 10px;
    }

    .site-menus {
        display: flex;
        align-items: center;
        margin: auto;
    }

    .menu-item {
        min-width: 80px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        position: relative;
    }

    .menu-item a {
        padding: 12px 10px;
        font-weight: 500;
        font-size: 16px;
    }

    .menu-item a:hover {
        color: #082F8F;
    }

    .hasChild:hover .childMenu {
        opacity: 1;
        visibility: visible;
        transform: translateY(-5px);
    }

    .childMenu {
        width: 130px;
        background-color: #FDFDFD;
        border-radius: 3px;
        border: 1px solid #ddd;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 55px;
        z-index: 2;
        opacity: 0;
        visibility: hidden;
        transition: .7s all ease;
        -webkit-transition: .6s all ease;
        -moz-transition: .6s all linear;
        -o-transition: .6s all ease;
        -ms-transition: .6s all ease;
    }

    .childMenu:before, .childMenu:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 8px solid white;
        top: -8px;
        left: 20px;
    }

    .sub-menu {
        height: 40px;
        line-height: 40px;
        position: relative;
    }

    .menu-user {
        padding-right: 70px;
    }
</style>
